import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

// Routes a non-platform-admin away from platform-only surfaces (e.g. /moderation).
// UI hygiene only — the server is already safe via the in-RPC platform-admin guard
// + the {authenticated} RLS. The flag is earmarked for the future Praetori console.
export default function PlatformAdminGate({ children }: { children: ReactNode }) {
  const isPlatformAdmin = useAuthStore((s) => s.user?.is_platform_admin === true);
  if (!isPlatformAdmin) return <Navigate to="/today" replace />;
  return <>{children}</>;
}
